<!-- eslint-disable max-lines -->
<!-- 逾期概览 -->
<template>
    <div class="page org-overdue">
        <div class="page-content">
            <!-- 条件筛选 -->

            <box :showheader="false" class="box-custom search-box">
                <div class="page-content-top">
                    <searchList :searchListConfig="searchListConfig" :roleCodes="roleCodes" :currentRole="currentRole"
                        :currentUserName="currentUserName" @resetCurrent="resetCurrent"
                        :searchOptionsList="searchOptionsList" @search-handle="searchHandle"
                        :searchInitData="searchInitData" />
                    <update-time @reset-current="resetCurrent" :updateTimeBigdataList="updateTimeBigdataList" />
                </div>
            </box>

            <div class="page-head-box">
                <!-- 逾期概览图表 -->
                <chartsData2 class="charts-conent mr10" :key="chartKey" :show-more-link="false"
                    :currentRole="currentRole" :config="_chartsConfig.overdueConfig"
                    :performanceData="overdueYearDetail" :chartsData="overdueYearData" />
                <box title="历史趋势" class="box-custom mr10">
                    <span class="tips" slot="header-right">鼠标按住拖拽可查看更多</span>
                    <ChartView :chart-option="historyBarOptions" width="100%" height="275px" />
                </box>
                <box title="各片区对比" class="box-custom">
                    <span class="tips" slot="header-right">鼠标按住拖拽可查看更多</span>
                    <!-- <el-radio-group slot="header-right" v-model="area.radioValue" size="mini"
                        @change="getOverdueAreaChartData">
                        <el-radio-button v-for="item in area.radioGroup" :key="item.value" :label="item.value">{{
                            item.label }}</el-radio-button>
                    </el-radio-group> -->
                    <ChartView :chart-option="areaBarOptions" width="100%" height="275px" />
                </box>
            </div>
            <!-- 外部各行业逾期情况 -->
            <box title="外部各行业逾期情况" class="box-custom" v-loading="outSideLoading">
                <table-item ref="outSideTableRef" :row-style="rowStyle1" :show-pagination="false"
                    :beforeRequest="outSideRequestConfig.beforeRequest"
                    :afterRequest="outSideRequestConfig.afterRequest" :height="outsideColumnsConfig.height"
                    :columns="outsideColumnsConfig.columns" :params="outSideParams">
                    <template v-slot:col-append="{ col, row }">
                        <span v-if="['overdueRate', 'dutyOverdueRate'].includes(col.prop)" class="danger-text">{{
                            row[col.prop] }}</span>
                        <span v-else-if="col.prop === 'typeName'" class="link"
                            @click="openOverdueCustomerDetailDialog(row)">{{ row[col.prop] }}</span>
                        <span v-else-if="['amtDue', 'amtOverdue', 'overdueRate', 'dutyOverdueRate'].includes(col.prop)"
                            :class="getCellClass(row[col.prop])">{{ row[col.prop] }}</span>
                    </template>
                </table-item>
            </box>
            <!-- 专司逾期情况 -->
            <box title="专司逾期情况" class="box-custom" v-loading="specialOfficeLoading">
                <table-item ref="specialOfficeTableRef" :row-style="rowStyle2" :show-pagination="false"
                    :beforeRequest="specialOfficeRequestConfig.beforeRequest"
                    :afterRequest="specialOfficeRequestConfig.afterRequest" :height="specialOfficeConfig.height"
                    :columns="specialOfficeConfig.columns" :params="specialOfficeParams">
                    <template v-slot:col-append="{ col, row }">
                        <span v-if="['overdueRate', 'dutyOverdueRate'].includes(col.prop)" class="danger-text">{{
                            row[col.prop] }}</span>
                        <span v-else-if="col.prop === 'bigEbcdNamed'" class="link"
                            @click="openOverdueCompanyDialog1(row, 'bigEbcdNamed')">{{ row[col.prop] }}</span>
                    </template>
                </table-item>
            </box>
            <!-- 分公司逾期情况 -->
            <box title="分公司逾期情况" class="box-custom" v-loading="branchOfficeLoading">
                <table-item ref="branchOfficeTableRef" :row-style="rowStyle3" :show-pagination="false"
                    :beforeRequest="branchOfficeRequestConfig.beforeRequest"
                    :afterRequest="branchOfficeRequestConfig.afterRequest" :height="branchOfficeColumnsConfig.height"
                    :columns="branchOfficeColumnsConfig.columns" :params="branchOfficeParams">
                    <template v-slot:col-append="{ col, row }">
                        <span v-if="['overdueRate', 'dutyOverdueRate'].includes(col.prop)" class="danger-text">{{
                            row[col.prop] }}</span>
                        <span v-else-if="col.prop === 'companyShortName'" class="link"
                            @click="openOverdueCompanyDialog1(row, 'company')">{{ row[col.prop] }}</span>
                    </template>
                </table-item>
            </box>

        </div>

        <!-- ===================================外部行业逾期客户详情弹窗 start=========================  -->
        <!-- 一级弹窗 -->
        <overdueDialog ref="overdueCustomerDetailDialogRef" :title="overdueCustomerDetailDialogTitle" :currentUser="{
            currentUserMip, currentUserName
        }" :config="overdueIndustryCategoryConfig" :getParams="overdueCustomerDetailParams" :roleCode="roleCodes"
            :currentRole="currentRole" @openCustomerGroup="openOverdueCustomerDetailDialog2" />

        <!-- 二级弹窗 -->
        <overdueDialog ref="overdueCustomerDetailDialogRef2" :title="overdueCustomerDetailDialogTitle2" :currentUser="{
            currentUserMip, currentUserName
        }" :config="customerGroupConfig" :getParams="overdueCustomerDetailParams2" :roleCode="roleCodes"
            @openCustomerDetail="openOverdueCustomerDetailDialog3" :currentRole="currentRole" />

        <!-- 三级弹窗 -->
        <overdueDialog ref="overdueCustomerDetailDialogRef3" :title="overdueCustomerDetailDialogTitle3" :currentUser="{
            currentUserMip, currentUserName
        }" :config="customerDetailConfig" :getParams="overdueCustomerDetailParams3" :roleCode="roleCodes"
            :currentRole="currentRole" />

        <!-- ===================================外部行业逾期客户详情弹窗 end=========================  -->

        <!-- ================================专司逾期情况客户详情/分公司逾期情况弹窗 start========================== -->

        <!-- 一级弹窗 -->
        <overdueDialog ref="overdueCompanyDialogRef1" :title="overdueCompanyDialogTitle1" :currentUser="{
            currentUserMip, currentUserName
        }" :config="overdueCompanyCustomerConfig" :getParams="overdueCustomerDetailParams2" :roleCode="roleCodes"
            @openCustomerDetail="openOverdueCompanyDialog2" :currentRole="currentRole" />

        <!-- 二级弹窗 -->
        <overdueDialog ref="overdueCompanyDialogRef2" :title="overdueCompanyDialogTitle2" :currentUser="{
            currentUserMip, currentUserName
        }" :config="overdueTimeDistributeConfig" :getParams="overdueCompanyDialogParams2" :roleCode="roleCodes"
            :currentRole="currentRole" />

        <!-- ================================专司逾期情况客户详情/分公司逾期情况 end========================== -->

    </div>
</template>
<script>
import { ref, onMounted, computed, getCurrentInstance, onActivated, watch } from '@vue/composition-api';
import searchList from '@/views/index/searchList/Index.vue';
import { getUserRoleList, queryUserDataAuth, getOverduePandectMonth, getOverduePandectYear } from '@/api/homePageApi';
import store from '@/store';
import updateTime from '@/views/components/UpdateTime.vue';
import box from '@/views/components/Box.vue';
import {
    outsideColumnsConfig, specialOfficeConfig, branchOfficeColumnsConfig, searchListConfig, updateTimeBigdataList,
    overdueIndustryCategoryConfig, customerGroupConfig, customerDetailConfig, overdueTimeDistributeConfig, overdueCompanyCustomerConfig
} from './column.config.js';
import { chartsConfig, formatValue, whileList } from '../../../index/config.js';
import chartsData2 from '@/views/index/chartsData/Index2.vue';
import _ from 'lodash';
import tableItem from '@/views/subPage/component/TableItem.vue';
import { getOverdueType, getOverdueCompany, getOverdueBigEbcdName, getOverdueHistory, getOverdueArea } from '@/api/subPageApi.js';
import ChartView from '@/lib/echarts/ChartView.vue';
import homeBgPic from '@/assets/images/homeBg.png';
import { testBar } from '@/lib/echarts/options/bar';
import { getSession } from '@/components/utils/storage';
import { useRowStyle } from '@/hook/style.js';
import overdueDialog from '../../component/incomeDialog/Index.vue';
export default {
    components: {
        searchList,
        updateTime,
        box,
        chartsData2,
        tableItem,
        ChartView,
        overdueDialog
    },
    // eslint-disable-next-line max-lines-per-function
    setup(props, setupContext) {
        const { userCode } = store.getters.user;
        // const homeLoading = ref(false);
        const outSideTableRef = ref(null);
        const specialOfficeTableRef = ref(null);
        const branchOfficeTableRef = ref(null);
        const currentRole = ref({});
        const currentUserName = ref('');
        const roleCodes = ref([]);
        const searchOptionsList = ref({});
        // 顶部筛选条件
        const searchData = ref({});
        // 表单筛选条件
        // 外部各行业收入情况
        // const area = reactive({
        //     radioValue: '合计',
        //     radioGroup: [{
        //         value: '合计',
        //         label: '合计'
        //     }, {
        //         value: '已开票',
        //         label: '已开票'
        //     }, {
        //         value: '未开票',
        //         label: '未开票'
        //     }]
        // });
        const historyBarOptions = ref({});
        const areaBarOptions = ref({});

        const rowStyle1 = ({ row, rowIndex }) => useRowStyle(row, rowIndex, 'typeName', ['合计']);
        const rowStyle2 = ({ row, rowIndex }) => useRowStyle(row, rowIndex, 'bigEbcdNamed', ['合计']);
        const rowStyle3 = ({ row, rowIndex }) => useRowStyle(row, rowIndex, 'companyShortName', ['合计']);

        const getPersonalParams = () => {
            let param = {};
            if (currentRole.value.dataType === 'personal') {
                param = _.cloneDeep(currentRole.value);
            }
            param.roleType = param.dataType;
            delete param.dataType;
            return param;
        };
        // 公用参数
        const getParams = computed(() => {
            return {
                refresh: true,
                transactionClassCode: `2`, // 默认外部
                serviceProductCode: `'all'`,
                organizationCode: `'all'`,
                industryTypeCode: `'all'`,
                userCode: userCode, // 测试账号
                dataType: isYear.value ? 'Y' : 'M',
                dataTime: isYear.value ? searchData.value.yearTime : searchData.value.monthTime,
                costType: isYear.value ? '2' : '1',
                customerlevelName: searchData.value.customerlevelName,
                ebcdCode: searchData.value.ebcdCode,
                typeId: searchData.value.typeId,
                areaCode: searchData.value.areaCode,
                subBranchCode: searchData.value.subBranchCode,
                type: isYear.value ? 'dashboard_income_angles_year' : 'dashboard_income_angles_month',
                businessSceneBigCategory: searchData.value.businessSceneBigCategory,
                bigEbcdName: searchData.value.bigEbcdName || '整体'
            };
        });

        // 外部各行业表格入参
        const outSideParams = computed(() => {
            return {
                ..._.pick(getParams.value, [
                    'refresh',
                    'dataType',
                    'dataTime',
                    'transactionClassCode',
                    'ebcdCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'userCode',
                    'bigEbcdName'
                ]),
                type: 'dashboard_overdue_type',
                systemType: '业务口径',
                tabType: '合计',
                abnormalOverdueCustomers: "'否'",
                customerLevelName: getParams.value.customerlevelName,
                api: getOverdueType
            };
        });

        // 专司逾期情况入参
        const specialOfficeParams = computed(() => {
            return {
                ..._.pick(getParams.value, [
                    'refresh',
                    'dataType',
                    'dataTime',
                    'transactionClassCode',
                    'ebcdCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'userCode',
                    'bigEbcdName'
                ]),
                type: 'dashboard_overdue_big_ebcd_name',
                systemType: '业务口径',
                tabType: '合计',
                abnormalOverdueCustomers: "'否'",
                customerLevelName: getParams.value.customerlevelName,
                api: getOverdueBigEbcdName
            };
        });

        // 分公司逾期情况入参
        const branchOfficeParams = computed(() => {
            return {
                ..._.pick(getParams.value, [
                    'refresh',
                    'dataType',
                    'dataTime',
                    'transactionClassCode',
                    'ebcdCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'userCode',
                    'bigEbcdName'
                ]),
                type: 'dashboard_overdue_company',
                systemType: '业务口径',
                tabType: '合计',
                abnormalOverdueCustomers: "'否'",
                customerLevelName: getParams.value.customerlevelName,
                bigEbcdNamed: '合计',
                customerName: '合计',
                api: getOverdueCompany
            };
        });

        const overdueCustomerDetailParams = computed(() => {
            return {
                ..._.pick(getParams.value, [
                    'refresh',
                    'dataType',
                    'dataTime',
                    'transactionClassCode',
                    'ebcdCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'userCode',
                    'bigEbcdName'
                ]),
                type: 'dashboard_overdue_type_industry',
                systemType: '业务口径',
                tabType: '合计',
                abnormalOverdueCustomers: "'否'"
            };
        });

        const overdueCustomerDetailParams2 = computed(() => {
            return {
                ..._.pick(getParams.value, [
                    'refresh',
                    'dataType',
                    'dataTime',
                    'transactionClassCode',
                    'ebcdCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'userCode',
                    'bigEbcdName'
                ]),
                type: 'dashboard_overdue_customer',
                systemType: '业务口径',
                tabType: '合计',
                abnormalOverdueCustomers: "'否'",
                qName: "'所有'"
            };
        });

        const overdueCustomerDetailParams3 = computed(() => {
            return {
                ..._.pick(getParams.value, [
                    'refresh',
                    'dataType',
                    'dataTime',
                    'transactionClassCode',
                    'ebcdCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'userCode',
                    'bigEbcdName'
                ]),
                type: 'dashboard_overdue_customer',
                systemType: '业务口径',
                tabType: '合计',
                abnormalOverdueCustomers: "'否'"
            };
        });

        const overdueCompanyDialogParams2 = computed(() => {
            return {
                ..._.pick(getParams.value, [
                    'refresh',
                    'dataType',
                    'dataTime',
                    'transactionClassCode',
                    'ebcdCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'userCode',
                    'bigEbcdName'
                ]),
                type: 'dashboard_overdue_time_distribute',
                systemType: '业务口径',
                tabType: '合计',
                abnormalOverdueCustomers: "'否'"
            };
        });

        // 外部各行业请求配置
        const outSideRequestConfig = {
            beforeRequest: (condition) => {
                return outSideParams.value;
            },
            afterRequest: (res) => {
                if (res && +res.code === 0) {
                    return {
                        data: res.data
                    };
                }
            }
        };

        // 分公司逾期情况入参
        const branchOfficeRequestConfig = {
            beforeRequest: (condition) => {
                return branchOfficeParams.value;
            },
            afterRequest: (res) => {
                if (res && +res.code === 0) {
                    return {
                        data: res.data
                    };
                }
            }
        };

        // 专司逾期情况请求配置
        const specialOfficeRequestConfig = {
            beforeRequest: (condition) => {
                return specialOfficeParams.value;
            },
            afterRequest: (res) => {
                if (res && +res.code === 0) {
                    return {
                        data: res.data
                    };
                }
            }
        };

        const isYear = computed(() => {
            return searchData.value?.timeStatus === 'year';
        });
        // 个人维度需要隐藏字段
        const hiddenPropHandle = (val) => {
            const data = _.cloneDeep(val);
            data.titleTips = '';
            data.titleTipsPersonal = '';
            if (currentRole.value.dataType === 'personal') {
                data.headConfig = data.headConfig.filter(it => !it.isHiddenPersonal);
            }
            return data;
        };
        // 根据年/月维度动态切换表格字段
        const _chartsConfig = computed(() => {
            return {
                overdueConfig: searchData.value.timeStatus === 'year' ? hiddenPropHandle(chartsConfig.overdueYear) : hiddenPropHandle(chartsConfig.overdueMonth)
            };
        });

        const setStrFormat = (val) => {
            if (!Array.isArray(val)) return val;
            return val?.map(item => `'${item}'`).join(',') || '';
        };

        // 外部行业逾期客户详情弹窗 1-1
        const overdueCustomerDetailDialogRef = ref(null);
        const overdueCustomerDetailDialogTitle = ref('');
        const openOverdueCustomerDetailDialog = (row) => {
            setupContext.refs.overdueCustomerDetailDialogRef.show({
                typeCode: row.typeId
            });
            overdueCustomerDetailDialogTitle.value = row.typeName;
        };

        // 外部行业逾期客户详情弹窗 1-2
        const overdueCustomerDetailDialogRef2 = ref(null);
        const overdueCustomerDetailDialogTitle2 = ref('');
        const openOverdueCustomerDetailDialog2 = (row) => {
            setupContext.refs.overdueCustomerDetailDialogRef2.show({
                typeCode: row.typeCode,
                industryCode: row.industryCode
            });
            overdueCustomerDetailDialogTitle2.value = row.row.industryName;
        };

        // 外部行业逾期客户详情弹窗 1-3
        const overdueCustomerDetailDialogRef3 = ref(null);
        const overdueCustomerDetailDialogTitle3 = ref('');
        const openOverdueCustomerDetailDialog3 = (row) => {
            setupContext.refs.overdueCustomerDetailDialogRef3.show({
                typeCode: 'heji',
                industryCode: 'heji',
                customerName: row.row.customerName
            });
            overdueCustomerDetailDialogTitle3.value = row.customerName;
        };

        // 专司逾期情况客户详情/分公司逾期情况弹窗 2-1
        const overdueCompanyDialogRef1 = ref(null);
        const overdueCompanyDialogTitle1 = ref('');
        const openOverdueCompanyDialog1 = (row, type) => {
            // 分公司合并不需要弹窗
            const excludedIndustries = ['合计'];
            if (type === 'company' && excludedIndustries.includes(row.companyShortName)) return;

            // 专司逾期情况
            if (type === 'bigEbcdNamed') {
                setupContext.refs.overdueCompanyDialogRef1.show({
                    companyCode: 'heji',
                    bigEbcdNamed: row.bigEbcdNamed,
                    dialogType: type
                });
            } else {
                // 分公司逾期情况
                setupContext.refs.overdueCompanyDialogRef1.show({
                    companyCode: row.companyCode,
                    bigEbcdNamed: '合计',
                    dialogType: type
                });
            }
            overdueCompanyDialogTitle1.value = row.bigEbcdNamed || row.companyShortName;
        };

        // 专司逾期情况客户详情/分公司逾期情况弹窗 2-2
        const overdueCompanyDialogRef2 = ref(null);
        const overdueCompanyDialogTitle2 = ref('');
        const openOverdueCompanyDialog2 = (row) => {
            const params = {
                bigEbcdNamed: row.bigEbcdNamed,
                customerLevelName: row.row.customerlevelName,
                customerName: row.customerName,
                companyCode: 'heji'
            };
            if (row.dialogType === 'company') {
                params.companyCode = row.companyCode;
            }
            setupContext.refs.overdueCompanyDialogRef2.show(params);
            overdueCompanyDialogTitle2.value = row.customerName;
        };
        const setCommaStrFormat = (val) => {
            let str = '';
            for (let i = 0; i < val.length; i++) {
                if (val[i].indexOf(',') >= 0) {
                    const arr = val[i].split(',');
                    for (let j = 0; j < arr.length; j++) {
                        str += "'" + arr[j] + "',";
                    }
                } else {
                    str += "'" + val[i] + "',";
                }
            }
            return str.substring(0, str.length - 1); // 删除最后的逗号
        };

        // 筛选赋值
        const searchHandle = (val) => {
            searchData.value = _.cloneDeep(val);
            if (val.industryCategory?.length) {
                searchData.value.typeId = val.industryCategory.map(it => it[0]);
            } else {
                searchData.value.typeId = [];
            }
            searchData.value.ebcdCode = setCommaStrFormat(searchData.value.ebcdCode) || "'all'"; // 专业公司编码
            searchData.value.typeId = setStrFormat(searchData.value.typeId) || "'all'"; // 行业大类
            searchData.value.areaCode = setStrFormat(searchData.value.areaCode) || "'all'"; // 片区
            searchData.value.subBranchCode = setStrFormat(searchData.value.subBranchCode) || "'all'"; // 分公司
            searchData.value.businessSceneBigCategory = setStrFormat(searchData.value.businessSceneBigCategory) || "'all'"; // 业务场景
            getAllData();
        };

        // 获取页面所有数据
        const getAllData = () => {
            if (isYear.value) {
                getOverduePandectYearInfo();
            } else {
                getOverduePandectMonthInfo();
            }
            getOverdueHistoryChartData();
            getOverdueAreaChartData();
        };
        const resetCurrent = () => {
            getAllData(true);
        };
        const currentUserMip = ref('');
        // 获取用户角色list
        // eslint-disable-next-line max-lines-per-function
        const getUserRoleInfo = () => {
            if (currentRole.value.dataType && store.getters.homePageParams?.dataType === 'personal') return;
            const currentRoleHome = getSession('currentRoleHome');
            if (store.getters.homePageParams?.dataType || currentRoleHome?.dataType) {
                const _currentRole = _.pick(store.getters.homePageParams, [
                    'roleCode',
                    'roleName',
                    'dataType',
                    'sortNo'
                ]);
                currentRole.value = _currentRole.dataType ? _currentRole : currentRoleHome;
                return;
            }
            const params = { userCode: userCode };
            if (currentRole.value) {
                params.userRoleDataType = currentRole.value.dataType;
            }
            // homeLoading.value = true;

            return getUserRoleList(params).then(res => {
                if (res && +res.code === 0) {
                    currentUserMip.value = res.data.userCode;
                    currentUserName.value = res.data.userName;
                    roleCodes.value = res.data.roleCodes;
                    if (Array.isArray(roleCodes.value) && roleCodes.value?.length) {
                        currentRole.value = roleCodes.value[0];
                    }
                    // customerStatusList.value = statusList.customerList.filter(it => it.role.includes(String(currentRole.value.dataType)));
                    // customerActive.value = customerStatusList.value[0].type;
                } else {
                    // resetLoading.value = false;
                    // homeLoading.value = false;
                }
            }).catch(() => {
                // resetLoading.value = false;
                // homeLoading.value = false;
            }).finally(() => {
                // homePageShow.value = true;
            });
        };
        const ctx = getCurrentInstance();
        const searchInitData = ref({});
        const getUserDataInfo = () => {
            searchInitData.value = {};
            const params = {
                ...currentRole.value,
                roleType: currentRole.value.dataType
            };
            return queryUserDataAuth(params).then(res => {
                if (res && +res.code === 0) {
                    searchOptionsList.value = res.data;
                    searchInitData.value = store.getters.homePageParams;
                    currentUserMip.value = res.data.userCode;
                    currentUserName.value = res.data.userName;
                }
            });
        };

        // 逾期应收概-年
        const overdueYearDetail = ref({});
        const overdueYearData = ref([]);
        // eslint-disable-next-line max-lines-per-function
        const getOverduePandectYearInfo = (data = {}) => {
            //  TOP 和2024年才有数据
            const params = {
                ..._.pick(getParams.value, [
                    'refresh',
                    'transactionClassCode',
                    'businessSceneBigCategory',
                    'serviceProductCode',
                    'organizationCode',
                    'userCode',
                    'dataTime',
                    'customerlevelName',
                    'ebcdCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'bigEbcdName'
                ]),
                requestType: '2',
                systemType: '业务口径',
                customerLevelName: getParams.value.customerlevelName,
                abnormalOverdueCustomers: "'否'",
                type: 'dashboard_overdue_pandect_year',
                dataType: searchData.value.timeStatus === 'year' ? 'Y' : 'M',
                ...getPersonalParams()
            };
            delete params.serviceProductCode;
            return getOverduePandectYear(params).then(res => {
                if (res && +res.code === 0) {
                    if (res.data.length === 0) {
                        overdueYearDetail.value = {};
                        overdueYearData.value = [];
                        return;
                    }
                    overdueYearData.value = [{
                        name: '应收账款',
                        value: res.data[0].arAmt
                    }, {
                        name: '逾期账款',
                        value: res.data[0].amtOverdue
                    }, {
                        name: '本月到期',
                        value: res.data[0].amtDue
                    }];
                    const _data = _.cloneDeep(res.data[0]);
                    // eslint-disable-next-line guard-for-in
                    for (const item in _data) {
                        _data[item] = formatValue(_data[item]);
                    }
                    overdueYearDetail.value = _data;
                }
            });
        };
        // 逾期应收概-月
        // const overdueMonthDetail = ref([]);
        // eslint-disable-next-line max-lines-per-function
        const getOverduePandectMonthInfo = (data = {}) => {
            const params = {
                ..._.pick(getParams.value, [
                    'refresh',
                    'transactionClassCode',
                    'businessSceneBigCategory',
                    'serviceProductCode',
                    'organizationCode',
                    'userCode',
                    'dataTime',
                    'ebcdCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'bigEbcdName'
                ]),
                requestType: '2',
                systemType: '业务口径',
                dataType: searchData.value.timeStatus === 'year' ? 'Y' : 'M',
                customerLevelName: getParams.value.customerlevelName,
                abnormalOverdueCustomers: "'否'",
                type: 'dashboard_overdue_pandect_month',
                ...getPersonalParams()
            };
            delete params.serviceProductCode;
            return getOverduePandectMonth(params).then(res => {
                if (res && +res.code === 0) {
                    if (res && +res.code === 0) {
                        if (res.data.length === 0) {
                            overdueYearDetail.value = {};
                            overdueYearData.value = [];
                            return;
                        }
                        overdueYearData.value = [{
                            name: '应收账款',
                            value: res.data[0].arAmt
                        }, {
                            name: '逾期账款',
                            value: res.data[0].amtOverdue
                        }, {
                            name: '本月到期',
                            value: res.data[0].amtDue
                        }];
                        const _data = _.cloneDeep(res.data[0]);
                        // eslint-disable-next-line guard-for-in
                        for (const item in _data) {
                            _data[item] = formatValue(_data[item]);
                        }
                        overdueYearDetail.value = _data;
                    }
                }
            });
        };

        // eslint-disable-next-line max-lines-per-function
        const setLineOption = (data = {}, chartType) => {
            const option = testBar({
                xAxis: data.xAxis,
                series: [{
                    name: '应收账款',
                    type: 'bar',
                    barWidth: 8, // 柱子宽度为类目宽度的 20%
                    data: data.dataList.map(it => it.arAmt)
                }, {
                    name: '逾期账款',
                    type: 'bar',
                    barWidth: 8, // 柱子宽度为类目宽度的 20%
                    data: data.dataList.map(it => it.amtOverdue)
                }, {
                    name: '本月到期',
                    type: 'bar',
                    barWidth: 8,
                    data: data.dataList.map(it => it.amtDue)
                }, {
                    name: '未到期',
                    type: 'bar',
                    barWidth: 8,
                    data: data.dataList.map(it => it.amtNotdue)
                }, {
                    name: '逾期率',
                    type: 'line',
                    yAxisIndex: 1,
                    // data: data.dataList.map(it => it.overdueRate),
                    data: data.dataList.map(it => {
                        // 将 '7.4399%' 转换为 7.4399
                        const rate = it.overdueRate;
                        return typeof rate === 'string' ? parseFloat(rate.replace('%', '')) : rate;
                    })
                }, {
                    name: '风险计提',
                    type: 'bar',
                    barWidth: 8,
                    data: data.dataList.map(it => it.riskAccrual)
                }]
            });

            if (chartType === 'history') {
                historyBarOptions.value = option;
            } else {
                areaBarOptions.value = option;
            }
        };

        // 历史趋势图表及片区对比图表
        // eslint-disable-next-line max-lines-per-function
        const getOverdueHistoryChartData = (data = {}) => {
            const params = {
                ..._.pick(getParams.value, [
                    'refresh',
                    'dataType',
                    'dataTime',
                    'businessSceneBigCategory',
                    'serviceProductCode',
                    'ebcdCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'userCode',
                    'bigEbcdName'
                ]),
                // type: 'dashboard_overdue_history',
                transactionClassCoded: `'4'`,
                transactionClassCode: `'2'`,
                systemType: '业务口径',
                tabType: '合计',
                customerLevelName: getParams.value.customerlevelName,
                abnormalOverdueCustomers: "'否'",
                'type': 'dashboard_overdue_history',
                ...getPersonalParams()
            };
            // 历史趋势图表
            getOverdueHistory(params).then(res => {
                if (res && +res.code === 0) {
                    const xAxis = res.data.map(it => it.dataTime);
                    setLineOption({
                        xAxis: xAxis,
                        dataList: res.data || []
                    }, 'history');
                } else {
                    setLineOption({
                        xAxis: [],
                        dataList: []
                    }, 'history');
                }
            });
        };

        // 各片区对比图表
        // eslint-disable-next-line max-lines-per-function
        const getOverdueAreaChartData = (data = {}) => {
            const params = {
                ..._.pick(getParams.value, [
                    'refresh',
                    'dataType',
                    'dataTime',
                    'businessSceneBigCategory',
                    'serviceProductCode',
                    'ebcdCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'userCode',
                    'bigEbcdName'
                ]),
                // type: 'dashboard_overdue_history',
                transactionClassCoded: `'4'`,
                transactionClassCode: `'2'`,
                systemType: '业务口径',
                tabType: '合计',
                customerLevelName: getParams.value.customerlevelName,
                abnormalOverdueCustomers: "'否'",
                'type': 'dashboard_overdue_area',
                ...getPersonalParams()
            };
            // 各片区对比图表
            getOverdueArea(params).then(res => {
                if (res && +res.code === 0) {
                    const xAxis = res.data?.map(it => it.areaName);
                    setLineOption({
                        xAxis: xAxis,
                        dataList: res.data || []
                    }, 'area');
                } else {
                    setLineOption({
                        xAxis: [],
                        dataList: []
                    }, 'area');
                }
            });
        };

        onMounted(async () => {
            document.querySelector('.el-main').style['background']
                = `linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1)),url(${homeBgPic}) center / 100% 100% no-repeat`;
        });
        const chartKey = ref(1);
        onActivated(async () => {
            ++chartKey.value;
            await getUserRoleInfo();
            await getUserDataInfo();
        });
        watch(
            () => ctx.$route,
            (newVal) => {
                if (!whileList.includes(newVal.name) && document.querySelector('.el-main')) {
                    document.querySelector('.el-main').style['background'] = '#f3f4f6';
                } else if (document.querySelector('.el-main')) {
                    document.querySelector('.el-main').style['background']
                        = `linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1)),url(${homeBgPic}) center / 100% 100% no-repeat`;
                }
            },
            { immediate: true } // 不设置的话，初始化加载时不会执行
        );

        // 表格loading状态统一管理
        const getTableLoading = (tableRef) => computed(() => tableRef.value?.tableListInstance?.tableLoading);
        // 外部各行业逾期情况loading
        const outSideLoading = getTableLoading(outSideTableRef);
        // 专司逾期情况loading
        const specialOfficeLoading = getTableLoading(specialOfficeTableRef);
        // 分公司逾期情况loading
        const branchOfficeLoading = getTableLoading(branchOfficeTableRef);

        return {
            currentRole,
            currentUserName,
            roleCodes,
            searchOptionsList,
            searchHandle,
            resetCurrent,
            outsideColumnsConfig,
            specialOfficeConfig,
            branchOfficeColumnsConfig,
            chartsConfig,
            // area,
            overdueYearDetail,
            searchData,
            getOverduePandectYearInfo,
            getOverduePandectMonthInfo,
            overdueYearData,
            branchOfficeParams,
            specialOfficeParams,
            _chartsConfig,
            isYear,
            searchInitData,
            outSideRequestConfig,
            branchOfficeRequestConfig,
            specialOfficeRequestConfig,
            outSideParams,
            searchListConfig,
            historyBarOptions,
            areaBarOptions,
            setLineOption,
            getOverdueAreaChartData,
            outSideLoading,
            specialOfficeLoading,
            branchOfficeLoading,
            outSideTableRef,
            specialOfficeTableRef,
            branchOfficeTableRef,
            chartKey,
            updateTimeBigdataList,
            rowStyle1,
            rowStyle2,
            rowStyle3,
            currentUserMip,
            overdueCustomerDetailDialogTitle,
            overdueIndustryCategoryConfig,
            customerGroupConfig,
            overdueCustomerDetailParams,
            overdueCustomerDetailDialogRef,
            openOverdueCustomerDetailDialog,
            overdueCustomerDetailDialogRef2,
            overdueCustomerDetailDialogTitle2,
            openOverdueCustomerDetailDialog2,
            overdueCustomerDetailParams2,
            overdueCustomerDetailDialogTitle3,
            overdueCustomerDetailParams3,
            overdueCustomerDetailDialogRef3,
            openOverdueCustomerDetailDialog3,
            customerDetailConfig,
            overdueTimeDistributeConfig,
            overdueCompanyDialogRef1,
            overdueCompanyDialogTitle1,
            openOverdueCompanyDialog1,
            overdueCompanyDialogRef2,
            overdueCompanyDialogTitle2,
            overdueCompanyDialogParams2,
            openOverdueCompanyDialog2,
            overdueCompanyCustomerConfig
        };
    }
};
</script>
<style scoped lang="less">
.page {
    min-width: 1500px;
    width: 100%;

    .c-item-up-bg {
        color: #F56C6C;
    }

    .c-item-down-bg {
        color: #67C23A;
    }

    &-content {
        width: 100%;
        padding: 0 0 10px 0;

        .page-head-box {
            display: flex;
            flex-direction: row;
            justify-content: space-evenly;
        }

        // 图表
        .charts-conent {
            width: calc(100%);
            padding: 16px;
            box-sizing: border-box;
            border-radius: 4px;
            border: 1px solid #FFFFFF;
            backdrop-filter: blur(25px);
            background: #ffffff;
            //  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            // 最后一个元素不要margin-bottom
            margin-bottom: 10px;

        }

        .search-box {
            position: sticky;
            top: 0;
            z-index: 100;
            backdrop-filter: blur(25px);
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.9) 100%);
            box-shadow: 0 2px 8px rgba(136, 136, 136, 0.1);
        }

        .mr10 {
            margin-right: 10px;
        }

        // 按钮组
        .search-radio {
            margin-bottom: 10px;

            // 深度选择
            /deep/ .el-radio-button__inner {
                padding: 5px 15px;
            }

            /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                color: #2881FF;
                border-color: #2881FF;
                background-color: #E5F0FE;
            }

            /deep/ .el-radio-button:first-child:last-child .el-radio-button__inner {
                border-radius: 0px 2px 2px 0px !important;
            }
        }

        .box-custom {
            margin-bottom: 10px;

            .danger-text {
                color: #F56C6C;
            }

            .link {
                color: #4285f5;
                cursor: pointer;
            }
        }

        .page-content-top {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .tips {
            font-size: 12px;
            color: #999;
        }
    }
}
</style>
